import { Link } from "react-router-dom";
import LoginBanner from "../assets/login-bg-11.jpg";
import {
  TextInput,
  PasswordInput,
  SelectInput,
  CheckBoxInput,
  RadioInput,
} from "../components/common/ui/Inputs";
import { useEffect, useState } from "react";
import userRegisterSchema from "../validation/userRegisterSchema";
import { useDispatch, useSelector } from "react-redux";
import { userRegisterAction } from "../_store/userRegister.slice";
import formatPhoneNumber from "../_helpers/formatPhoneNumber";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";
import Button from "../components/common/ui/Button";
import { decryptData, encryptData } from "../utils/encryptDecrypt";
import { Popup } from "../components/common/ui/NotificationModal/Popup";
import { history } from "../_helpers";
import { useNavigate } from "react-router-dom";
import otpSchema from "../validation/otpSchema";
import MultiSelectDropdown from "../components/common/ui/Inputs/MultiSelectDropdown";

function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { signUpResponse, committeesList, otpResponse } = useSelector(
    (x) => x?.register,
  );
  const { statusOptions } = useSelector((x) => x?.dropDown);

  // State for Registration Form
  const initialRegisterForm = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    committees: [],
    organization: "",
    privateMember: false,
    participateKids: 0,
  };

  const [registerForm, setRegisterForm] = useState(initialRegisterForm);

  // State for verify OTP
  const [verifyOTP, setVerifyOTP] = useState({
    email: "",
    otp: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [closeModalPopup, setCloseModalPopup] = useState(false);
  const [submit, setSubmit] = useState(false);

  // Initial component mount call the committees list API
  useEffect(() => {
    dispatch(userRegisterAction?.getCommitteesList());
  }, [dispatch]);

  // Get the registration response here
  // useEffect(() => {
  //   if (signUpResponse?.status !== undefined) {
  //     switch (signUpResponse.status) {
  //       case 1:
  //         showToastNotification(signUpResponse?.message, "success");
  //         setSubmit(false);
  //         setRegisterForm(initialRegisterForm);
  //         // Show the Verify OTP model
  //         const modalElement = document.getElementById("add-VerifyOTP-modal");
  //         if (modalElement) {
  //           const modal = new Modal(modalElement);
  //           modal.show();
  //         }
  //         break;
  //       case 0:
  //         showToastNotification(signUpResponse?.message, "danger");
  //         setSubmit(false);
  //         setRegisterForm(initialRegisterForm);
  //         break;

  //       default:
  //         showToastNotification("Something went wrong", "warning");
  //         setSubmit(false);
  //         break;
  //     }
  //   }
  // }, [signUpResponse]);

  // Get verify OTP Response here
  useEffect(() => {
    if (otpResponse?.status !== undefined) {
      switch (otpResponse?.status) {
        case 1:
          showToastNotification(
            "One-Time Code Verified Successfully",
            "success",
          );
          setSubmit(false);
          setCloseModalPopup(true);
          setVerifyOTP({ email: "", otp: "" });
          dispatch(userRegisterAction?.clearOTPResponse());
          break;
        default:
          showToastNotification("Something went wrong", "warning");
          setSubmit(false);
          break;
      }
    }
  }, [otpResponse, dispatch]);

  const calculateNewCursorPosition = (oldPos, oldValue, newValue) => {
    let rawIndex = 0;
    let newIndex = 0;

    while (rawIndex < oldPos && newIndex < newValue.length) {
      if (/\d/.test(oldValue[rawIndex])) {
        while (newIndex < newValue.length && !/\d/.test(newValue[newIndex])) {
          newIndex++;
        }
        newIndex++;
      }
      rawIndex++;
    }
    return newIndex;
  };

  const handleRegisterFormChanges = (e, customName) => {
    debugger;
    const updatedForm = { ...registerForm };

    const target = e?.target || {};
    const name = customName || target.name;

    if (!name) return;

    let value;

    // Determine value based on input type
    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "radio") {
      value = parseInt(target.value);
    } else {
      value = customName ? e?.value || "" : target.value;

      // Prevent value starting with single space
      //if (typeof value === "string" && value.trimStart().length === 0) return;
    }

    //    if (name === "firstName" || name === "lastName") {
    //   const regex = /^[A-Za-z0-9 '@-]*$/;
    //   if (!regex.test(value)) {
    //     return; // block invalid characters
    //   }
    // }

    // Special case: phone number formatting
    if (name === "phoneNumber") {
      const selectionStart = target.selectionStart || 0;
      const digitsOnly = value.replace(/\D/g, "");
      const formattedNumber = formatPhoneNumber(digitsOnly);

      requestAnimationFrame(() => {
        const inputElem = document.querySelector(`input[name="phoneNumber"]`);
        if (inputElem) {
          const newCursorPos = calculateNewCursorPosition(
            selectionStart,
            value,
            formattedNumber,
          );
          inputElem.setSelectionRange(newCursorPos, newCursorPos);
        }
      });

      updatedForm[name] = formattedNumber;
      setRegisterForm(updatedForm);
      return;
    }

    // Email and general input character validation
    // const regexMap = {
    //   email: /^[a-zA-Z0-9_@.\s]*$/,
    //   password: /^[\x20-\x7E]*$/, // allows all printable ASCII characters
    //   confirmPassword: /^[\x20-\x7E]*$/, // same as password
    //   default: /^[a-zA-Z0-9\s]*$/,
    // };
    const regexMap = {
      // email: /^[a-zA-Z0-9.@_\s]*$/, // letters, numbers, underscore, @, dot, space
      email: /^[a-zA-Z0-9.@!#$*+-_\s]*$/, // letters, numbers, underscore, @, dot, space
      password: /^[\x20-\x7E]*$/, // all printable ASCII
      confirmPassword: /^[\x20-\x7E]*$/, // same as password
      // firstName: /^[A-Za-z '@-]*$/, // letters, numbers, space, apostrophe, hyphen, @
      firstName: /^[A-Za-z0-9 ]*$/,
      lastName: /^[A-Za-z0-9 ]*$/,
      default: /^[a-zA-Z0-9\s]*$/, // fallback for other fields
    };

    const isValid =
      typeof value !== "string" ||
      (regexMap[name] || regexMap.default).test(value);

    if (!isValid) return;
    if (typeof value === "string") if (value.startsWith(" ")) return;

    updatedForm[name] = value;
    setRegisterForm(updatedForm);
  };

  const togglePasswordVisibility = (type) => {
    type === "password"
      ? setShowPassword((prev) => !prev)
      : setShowConfirmPassword((prev) => !prev);
  };
  const restrictCharacters = (e, restrictedChars = ["'", "`"]) => {
    if (restrictedChars.includes(e.key)) {
      e.preventDefault(); // Prevent the restricted character from being entered
    }
  };



  const handleSelectChange = (selectedOptions, fieldName) => {
    const selectedIds = selectedOptions?.map((item) => item.value) || [];

    setRegisterForm((prevForm) => ({
      ...prevForm,
      [fieldName]: selectedIds,
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    setErrorMessage({});
    setSubmit(true);
    const { error } = userRegisterSchema(registerForm);

    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });

      // Scroll to first error field
      const firstErrorField = error.details[0]?.path?.[0];
      const errorElement = document.getElementById(firstErrorField);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus();
      }

      return;
    }

    setVerifyOTP((prevState) => ({
      ...prevState,
      email: registerForm?.email,
    }));

    const encryptPassword = encryptData(registerForm?.password);

    const finalForm = {
      ...registerForm,
      // committees: registerForm.committees.map((c) => c.value),
      password: encryptPassword,
      confirmPassword: encryptPassword,
    };
    //API call after validation
    dispatch(userRegisterAction?.signUp(finalForm))
      .then((result) => {
        setSubmit(false);
        if (result?.payload?.status === 1) {
          Popup({
            title: "Message",
            text: `${result?.payload?.message}`,
            icon: "success",
            confirmButtonText: "OK",
            onConfirm: () => {
              history?.navigate("/register/OTP", {
                state: {
                  email: finalForm.email, // send the email if you need it in the OTP page
                  from: "register",
                },
              });
            },
          });
          setSubmit(false);
          setRegisterForm(initialRegisterForm);
        } else {
          Popup({
            title: "Message",
            text: `${result?.error?.message}`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        Popup({
          title: "Message",
          text: `Failed to create committee`,
          icon: "error",
          confirmButtonText: "OK",
        });
        setSubmit(false);
      });
  };

  const submitVerifyOTP = (e) => {
    e?.preventDefault();

    setErrorMessage({});
    setSubmit(true);
    const { error } = otpSchema(verifyOTP);
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    dispatch(userRegisterAction?.verifyOTP(verifyOTP))
      .then((result) => {
        setSubmit(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          setSubmit(false);
          setRegisterForm(initialRegisterForm);

        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setSubmit(false);
      });
  };

  return (
    <section className="register-section">
      <div className="container">
        <div className="register-card">
          <h2 className="registerform-label">Membership Registration</h2>

          <form
            role="search"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <div className="row gx-3 d-flex justify-content-center">
              <div className="col-md-6 mb-2 mb-md-0">
                <TextInput
                  name="firstName"
                  id="firstName"
                  placeholder="First name"
                  label="First Name"
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  required
                  value={registerForm?.firstName}
                  maxLength={25}
                  errorMessage={errorMessage}
                />
              </div>
              <div className="col-md-6">
                <TextInput
                  name="lastName"
                  id="lastName"
                  label="Last Name"
                  placeholder={"Last name"}
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  required
                  value={registerForm?.lastName}
                  maxLength={25}
                  errorMessage={errorMessage}
                />
              </div>
            </div>

            <div className="row gx-3 d-flex justify-content-center">
              <div className="col-md-6 mb-2 mb-md-0">
                <TextInput
                  name="email"
                  id="email"
                  label={"Email"}
                  placeholder={"Email address"}
                  required
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  value={registerForm?.email}
                  maxLength={100}
                  errorMessage={errorMessage}
                />
              </div>
              <div className="col-md-6">
                <TextInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={"Phone number"}
                  placeholder="(000) 000-0000"
                  // required
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  // maxLength={10}
                  value={registerForm?.phoneNumber}
                  errorMessage={errorMessage}
                />
              </div>
            </div>

            <div className="row gx-3 d-flex justify-content-center">
              <div className="col-md-6 mb-2 mb-md-0">
                <PasswordInput
                  name="password"
                  ariaLabel="Password"
                  id="Password"
                  label="Password"
                  onKeyDown={(e) => restrictCharacters(e)}
                  value={registerForm?.password}
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  placeholder="Password"
                  required={true}
                  errorMessage={errorMessage}
                  showPassword={showPassword}
                  togglePasswordVisibility={() =>
                    togglePasswordVisibility("password")
                  }
                  autoComplete="new-password"
                  maxlength={25}
                //   handleBlur={handleBlur}   // temporarly Commented
                />
              </div>
              <div className="col-md-6 mb-2">
                <PasswordInput
                  name="confirmPassword"
                  id="confirmPassword"
                  label="Confirm Password"
                  ariaLabel="Confirm Password"
                  onKeyDown={(e) => restrictCharacters(e)}
                  value={registerForm?.confirmPassword}
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  placeholder="Confirm Password"
                  required={true}
                  errorMessage={errorMessage}
                  showPassword={showConfirmPassword}
                  togglePasswordVisibility={() =>
                    togglePasswordVisibility("confirm")
                  }
                  autoComplete="new-password"
                  maxlength={25}

                />
              </div>
            </div>

            <div className="mb-2">

              <MultiSelectDropdown
                name="committees"
                options={committeesList?.data}
                displayValue="label"
                handleChange={(e) => handleSelectChange(e, "committees")}
                placeholder="Choose Committee"
                label="Choose Committee"
                ariaLabel="Choose Committee"
                required
                errorMessage={errorMessage}
                selectedValue={
                  Array.isArray(committeesList?.data) &&
                    Array.isArray(registerForm?.committees)
                    ? committeesList.data.filter((option) =>
                      registerForm.committees.includes(option.value),
                    )
                    : []
                }
              />
            </div>
            <div className="mb-2">
              <RadioInput
                name="participateKids"
                id="participateKids"
                label="Are you participating in the Broward Partnerships for Kids as part of your professional reasons?"
                options={statusOptions}
                selectedValue={registerForm?.participateKids} // Get value from Redux store
                handleChange={handleRegisterFormChanges}
              />
            </div>
            {registerForm?.participateKids === 1 && (
              <div className="fs-5 text-gray">
                “If yes, then please add your organization"
              </div>
            )}
            <div className="mb-4">
              <TextInput
                name="organization"
                id="organization"
                label={"Organization"}
                placeholder={"Organization"}
                required={registerForm?.participateKids ? true : false}
                handleChange={(e) => {
                  handleRegisterFormChanges(e);
                }}
                value={registerForm?.organization}
                maxLength={256}
                errorMessage={errorMessage}
                ariaLabel="organization"
              />
            </div>

            <div className="mb-4">
              <CheckBoxInput
                label="Private Member"
                name="privateMember"
                id={"privateMember"}
                handleClick={handleRegisterFormChanges}
                checked={registerForm?.privateMember}
              />
              <div className="fs-5 text-gray">
                Selecting the checkbox will display only your name, other
                details will remain hidden from committee members.
              </div>
            </div>



            <div className="div-center">
              <button
                type="submit"
                className="sign-in-button"
                disabled={submit}
              >
                Register{" "}
                {!submit ? (
                  <i className="css-arrow-icon bi bi-arrow-right"></i>
                ) : (
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                )}
              </button>
            </div>

            <div className=" mt-4">
              Already Have An Account?{" "}
              <Link
                to="/login"
                className=" text-decoration-none"
                aria-label="Login to your account"
              >
                Login
              </Link>
            </div>
          </form>
          {/* <div className=""> */}
          {/* ---------- Left Panel ---------------- */}
          {/* <div className="news-feed">
          <img src={LoginBanner} alt="Broward Partnerships for Kids Banner" />
          <div className="news-caption">
            <h4 className="caption-title">
              <b>BROWARD PARTNERSHIPS FOR KIDS</b>
            </h4>
            <p>
              Lorem ipsum is a dummy or placeholder text commonly used in
              graphic design, publishing, and web development.
            </p>
          </div>
        </div> */}
          {/* ---------- Right Panel ------------- */}
          {/* <div className="register-container">
          <div className="register-header mb-25px h1">
            <div className="mb-1">Sign Up</div>
            <small className="d-block fs-15px lh-16">
              Create your Color Admin Account. It’s free and always will be.
            </small>
          </div>

          <div className="register-content">
            <form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
              className=""
              // className="fs-13px"
            >
              <div className="mb-2">
                <div className="row gx-3 d-flex justify-content-center">
                  <div className="col-md-6 mb-2 mb-md-0">
                    <TextInput
                      name="firstName"
                      id="firstName"
                      placeholder="First name"
                      label="First Name"
                      handleChange={(e) => {
                        handleRegisterFormChanges(e);
                      }}
                      required
                      value={registerForm?.firstName}
                      maxLength={25}
                      errorMessage={errorMessage}
                    />
                  </div>
                  <div className="col-md-6">
                    <TextInput
                      name="lastName"
                      id="lastName"
                      label="Last Name"
                      placeholder={"Last name"}
                      handleChange={(e) => {
                        handleRegisterFormChanges(e);
                      }}
                      value={registerForm?.lastName}
                      maxLength={25}
                      errorMessage={errorMessage}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-2">
                <TextInput
                  name="email"
                  id="email"
                  label={"E-mail"}
                  placeholder={"Email address"}
                  required
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  value={registerForm?.email}
                  maxLength={50}
                  errorMessage={errorMessage}
                />
              </div>

              <div className="mb-2">
                <TextInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={"Phone number"}
                  placeholder="(000) 000-0000"
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  // maxLength={10}
                  value={registerForm?.phoneNumber}
                  errorMessage={errorMessage}
                />
              </div>

              <div className="mb-2">
                <PasswordInput
                  name="password"
                  id="Password"
                  label="Password"
                  onKeyDown={(e) => restrictCharacters(e)}
                  value={registerForm?.password}
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  placeholder="Password"
                  required={true}
                  errorMessage={errorMessage}
                  showPassword={showPassword}
                  togglePasswordVisibility={togglePasswordVisibility}
                  autoComplete="new-password"
                  maxlength={25}
                  //   handleBlur={handleBlur}   // temporarly Commented
                />
              </div>

              <div className="mb-4">
                <PasswordInput
                  name="confirmPassword"
                  id="confirmPassword"
                  label="Confirm Password"
                  onKeyDown={(e) => restrictCharacters(e)}
                  value={registerForm?.confirmPassword}
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  placeholder="Confirm Password"
                  required={true}
                  errorMessage={errorMessage}
                  showPassword={showPassword}
                  togglePasswordVisibility={togglePasswordVisibility}
                  autoComplete="new-password"
                  maxlength={25}
                  //   handleBlur={handleBlur}   // temporarly Commented
                />
              </div>
              <div className="mb-4">
                <SelectInput
                  name="committees"
                  label="Communities of Interest” to “Select the Broward Partnerships for Kids committee(s) that you would like to participate in"
                  options={committeesList?.data || []}
                  isMulti={true}
                  required
                  value={registerForm?.committees}
                  errorMessage={errorMessage}
                  handleChange={(selectedOptions) =>
                    handleSelectChange(selectedOptions, "committees")
                  }
                />
              </div>
              <div className="mb-2">
                <RadioInput
                  name="participateKids"
                  id="participateKids"
                  label="Are you participating in the Broward Partnerships for Kids as part of your professional reasons?"
                  options={statusOptions}
                  selectedValue={registerForm?.participateKids} // Get value from Redux store
                  handleChange={handleRegisterFormChanges}
                />
              </div>
              <div className="mb-4">
                <TextInput
                  name="organization"
                  id="organization"
                  label={"Organization"}
                  placeholder={"Organization"}
                  //required
                  handleChange={(e) => {
                    handleRegisterFormChanges(e);
                  }}
                  value={registerForm?.organization}
                  maxLength={30}
                  disabled={registerForm?.participateKids === 0}
                  errorMessage={errorMessage}
                />
              </div>
              <div className="mb-4">
                <CheckBoxInput
                  label="Private Member"
                  name="privateMember"
                  id={"privateMember"}
                  handleClick={handleRegisterFormChanges}
                  checked={registerForm?.privateMember}
                />
              </div>

              <div className="mb-4">
                <Button
                  label="Register"
                  status="primary"
                  type="submit"
                  disabled={submit}
                  className={"w-100 mt-3 font-size-16"}
                />
              </div>
              <div className="mb-4 pb-5">
                Already a member? Click{" "}
                <Link to="/login" aria-label="Login to your account">
                  here
                </Link>{" "}
                to login.
              </div>
            </form>
          </div>
        </div> */}
          {/* </div> */}
          {/* ------ Modal Popup for verify OTP page ------- */}
          {/* <CommonModal
        modalId="add-VerifyOTP-modal"
        title="Verify OTP"
        // handleCloseIcon={handleCloseIconInPopup} //for cross icons
        closeModalTrigger={closeModalPopup}
        bodyContent={
          <form
            className="d-flex flex-column gap-3"
            onSubmit={(e) => {
              submitVerifyOTP(e);
            }}
          >
            <TextInput
              name="otp"
              label="One-Time Code"
              placeholder="Enter the OTP"
              maxLength={6}
              value={verifyOTP?.otp}
              handleChange={(e) => {
                setVerifyOTP((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }));
              }}
              required
              errorMessage={errorMessage}
              handleBlur={(e) => {
                //  handleValidationForPopup(e, "categoryName");
              }}
            />
            <div className="d-flex justify-content-center">
              <Button
                className={"me-2"}
                label="Verify OTP"
                type="submit"
                status="primary"
                disabled={submit}
              />
              <Button
                className="me-2 "
                label="Close"
                type="reset"
                variant="danger"
                status={"secondary"}
                disabled={false}
                onClick={handleCloseOTPModel}
              />
            </div>
          </form>
        }
        modalSize="modal-md"
      /> */}
        </div>
      </div>
    </section>
  );
}

export default Register;
